export default __webpack_public_path__ + "static/waves-long-9da2a14056275f587d72ed8c35454dae.svg";